'use client';
import { ETSY_URL, GUMROAD_URL, INFINITEMARKET_URL } from '@/data/bundles';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      className="relative py-10"
      style={{ background: '#050810', borderTop: '1px solid rgba(30,41,59,0.4)' }}
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 mb-8">
          {/* Brand */}
          <div className="flex flex-col gap-1">
            <span className="font-extrabold text-base" style={{ color: 'var(--foreground)' }}>✦ Premium Bundle Vault</span>
            <span className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
              Digital product bundle from{' '}
              <a
                href="https://dailysparkdigitals.etsy.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors"
                style={{ color: 'var(--secondary-foreground)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--foreground)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--secondary-foreground)')}
                aria-label="Visit dailysparkdigitals on Etsy"
              >
                dailysparkdigitals
              </a>{' '}
              on Etsy
            </span>
          </div>

          {/* Nav */}
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm" style={{ color: 'var(--muted-foreground)' }} aria-label="Footer navigation">
            <button
              onClick={() => scrollTo('whats-included')}
              className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-sm font-medium"
              style={{ color: 'var(--muted-foreground)' }}
            >
              What&apos;s Included
            </button>
            <button
              onClick={() => scrollTo('faq')}
              className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-sm font-medium"
              style={{ color: 'var(--muted-foreground)' }}
            >
              FAQ
            </button>
            <a href={ETSY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors font-medium" style={{ color: 'var(--muted-foreground)' }}>Buy on Etsy</a>
            <a href={GUMROAD_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors font-medium" style={{ color: 'var(--muted-foreground)' }}>Buy on Gumroad</a>
            <a href={INFINITEMARKET_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors font-medium" style={{ color: 'var(--muted-foreground)' }}>Buy on InfiniteMarket</a>
            <a href="https://www.etsy.com/legal/privacy/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors font-medium" style={{ color: 'var(--muted-foreground)' }}>Etsy Privacy</a>
            <a href="https://www.etsy.com/legal/terms-of-use/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors font-medium" style={{ color: 'var(--muted-foreground)' }}>Etsy Terms</a>
          </nav>
        </div>

        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6"
          style={{ borderTop: '1px solid rgba(30,41,59,0.3)' }}
        >
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>© 2026 Premium Bundle Vault. All rights reserved.</p>
          <p className="text-xs text-center" style={{ color: 'var(--muted-foreground)' }}>
            Digital product. No physical item will be shipped. Not affiliated with or endorsed by Etsy, Gumroad or InfiniteMarket beyond selling through those platforms.
          </p>
        </div>
      </div>
    </footer>
  );
}
